<template>
  <div class="modal-backdrop" @click="$emit('close')">
    <div @click.stop class="modal" role="dialog" aria-labelledby="security-modal">

      <div class="modal-content">
        <header class="modal-header" id="security-modal">
          <h2 class="t2 fw-semibold mb-0">Your information is safe</h2>
          <button id="securityModalCloseBtn" type="button" class="btn-close" @click="$emit('close')" aria-label="Close modal"></button>
        </header>

        <section class="modal-body" id="security-modal-content">
          <div class="row text-center text-sm-start pb-4">
            <div class="col-12 col-sm-4 order-1 order-sm-2 text-center">
              <img class="max-w-152" src="../../assets/img/authorized-efile-provider-trans.png" alt="">
            </div>
            <div class="col-12 col-sm-8 order-2 order-sm-1">
              <h6 class="t2">Trusted company</h6>
              <p>As an authorized IRS e-file provider, we meet or exceed the security requirements outlined by the IRS.</p>
            </div>
          </div>
          <div class="row text-center text-sm-start pb-4">
            <div class="col-12 col-sm-4 order-1 order-sm-2 text-center">
              <img src="../../assets/img/sm_ccsafe_whborder.gif" alt="">
            </div>
            <div class="col-12 col-sm-8 order-2 order-sm-1">
              <h6 class="t2">Your payment cards are secure</h6>
              <p>We comply with rigorous data security standards to protect against theft of your payment information.</p>
            </div>
          </div>
          <div class="row text-center text-sm-start pb-4">
            <div class="col-12 col-sm-4 order-1 order-sm-2 text-center">
              <a href="//privacy.trustarc.com/privacy-seal/validation?rid=c42c3969-4ba9-45a8-a024-d06b6af0032e" target="_blank">
                <img class="border-none" src="//hostedseal.trustarc.com/privacy-seal/seal?rid=c42c3969-4ba9-45a8-a024-d06b6af0032e" alt="TRUSTe"/>
              </a>
            </div>
            <div class="col-12 col-sm-8 order-2 order-sm-1">
              <h6 class="t2">Privacy is our priority</h6>
              <p>Compliance to industry standards ensures adherence to privacy best practices.
                <button type="button" @click="showDifferentModal('security', 'privacy')">Read Privacy Policy</button>
              </p>
            </div>
          </div>
        </section>
      </div>

      <footer class="modal-footer">
        <button type="button" class="btn btn-white" @click="$emit('close')" aria-label="Close modal">Close</button>
      </footer>

    </div>
  </div>
</template>

<script setup>
import getModal from "@/functions/getModal"

const {showDifferentModal} = getModal()
const appName = sessionStorage.getItem('appName')
</script>

<style lang="scss" scoped>
img {
  max-width: 250px;
  padding-bottom: 1rem;

  @include breakpoint(sm) {
    padding-bottom: 0;
  }
}
</style>
